<template>
    <div class="users-style">

    <h4 class="atlhr-dashboard-title mt-10 px-0 mb-0">Leave & Attendance Settings<span>
        <a v-bind:href="$api_url+'/company/dashboard'">Dashboard</a> / Settings / Leave & Attendance Settings / Overtime Policy</span>
    </h4>

      <div id="settings" class="mt-4 employee-tab leave-attendance-dashboard">
        <b-tabs pills content-class="custom-tab-content" nav-wrapper-class="col-md-12 custom-tab-nav custom-margin ml-auto pl-0 bg-white" nav-class="mb-4 mt-3 leave-attendance-dashboard-tab">
        <b-tab>
          <template v-slot:title>
              <img v-bind:src="$api_url+'/images/roster-penalty-policies.png'"  class="img-fluid mr-2" height="30px" width="30px" />Overtime Policies
          </template>
          <div class="ibox-title dashboard_title company-form-box-title pf-contribution pl-0 pt-0 pb-0 roster-ibox">
            <h4 class="clearfix mb-0 mt-2">
              <span class="float-left">Overtime Policy
                  <span class="title-sub-text"></span>
              </span>
              <span class="float-right"></span>
            </h4>
          </div>
          
          <div class="d-flex bd-highlight py-2 mb-2 mt-3">
            <div class="custom-search w-100">
              <b-input-group class="mb-0">
                <b-input-group-prepend is-text>
                  <b-icon icon="search"></b-icon>
                </b-input-group-prepend>
                <b-form-input type="search" placeholder="Search.." v-model="search" @input="resetPagination()"></b-form-input>
              </b-input-group>
            </div>

            <div class="ml-auto">
              <b-button id="show-btn" @click="addNew()">+ Create Overtime Policy</b-button>
            </div>
          </div>

          <table class="table dataTable">
            <thead>
              <tr class="table-head">
                <template v-for="column in columns">
                  <template v-if="column.sort">
                    <th @click="sortBy(column.name)" :key="column.name"
                      :class="sortKey === column.name ? (sortOrders[column.name] > 0 ? 'sorting_asc' : 'sorting_desc') : 'sorting'"
                      class="cursor-pointer"><span>{{ column.label }}</span></th>
                  </template>
                  <th v-else :key="column.name"><span>{{ column.label }}</span></th>
                </template>
                <th class="text-right">Actions</th>
              </tr>
            </thead>
            <tbody>
            <tr class="hover-bg table-row mx-2" v-for="item in paginatedData" :key="item.id">
              <td>{{ item.name }}</td>
              <td>{{ yes_no[item.taxable].text }}</td>
              <td class="text-right">{{ item.min_minute }}</td>
              <td class="text-right">{{ parseInt(item.max_hours) }} hrs per {{ item.max_limit_type == 1 ? 'month' : 'day' }}</td>

              <td class="text-right position-relative">
                <a id="actionDropdown" class="dropdown-toggle clearfix action-dropdown-toggle"
                href="#" role="button" data-toggle="dropdown" aria-haspopup="true"
                  aria-expanded="false">
                  <b-icon icon="three-dots-vertical"></b-icon>
                </a>
                <div class="dropdown-menu action-dropdown-menu" aria-labelledby="actionDropdown">
                  <b-button-group>
                    <b-button variant="outline-secondary" @click="editData(item.id)">
                      <b-icon icon="pencil"></b-icon>
                      Edit
                    </b-button>
                    <b-button variant="outline-danger" @click="deleteData(item.id)">
                      <b-icon icon="trash"></b-icon>
                      Delete
                    </b-button>
                  </b-button-group>
                </div>
              </td>
            </tr>
            </tbody>
          </table>

          <div v-if="paginatedData.length == 0" class="px-3 py-3 no-result-cell">{{ blankmsg }}</div>
          <div v-else class="px-3">
            <ul class="pagination b-pagination float-left mb-0 mt-1">
              <li class="page-item disabled m-2">View</li>
              <li class="page-item disabled"><b-form-select v-model="temp_length" :options="length_options" @change="setFirstPage()"></b-form-select></li>
              <li class="page-item disabled m-2">per page. Total {{datalist.length}} records found.</li>
            </ul>
            <b-pagination-nav  v-model="pagination.currentPage" :number-of-pages="pagination.pages" base-url="#" prev-text="Previous" next-text="Next" first-number last-number ></b-pagination-nav>
          </div>
        </b-tab>

        <b-tab>
          <template v-slot:title>
              <img v-bind:src="$api_url+'/images/cf-fixed-benefits.png'"  class="img-fluid mr-2" height="30px" width="30px" />Policy Log
          </template>

          <div class="mt-3">
            <div class="ibox-title dashboard_title company-form-box-title pf-contribution pl-0 pt-0 pb-0 roster-ibox">
              <h4 class="clearfix mb-0">
                <span class="float-left">Policy Log
                    <span class="title-sub-text"></span>
                </span>
                <span class="float-right"></span>
              </h4>
            </div>
            
            <div class="table-responsive">
              <table class="table dataTable">
                <thead>
                  <tr class="table-head">
                    <th>Policy Name</th>
                    <th>Description</th>
                    <th class="text-right">Details</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="log in paginatedLogs" :key="log.id" class="hover-bg table-row mx-2">
                    <td>{{ log.policy_name }}</td>
                    <td>{{ log.action }}d By {{ log.activity_by }} at {{ formatDateTime(log.created_at) }}</td>
                    <td class="text-right position-relative">
                      <template v-if="log.details">
                        <a :id="'actionDropdown-log-' + log.id" class="dropdown-toggle clearfix action-dropdown-toggle"
                          href="#" role="button" data-toggle="dropdown" aria-haspopup="true"
                          aria-expanded="false">
                          <b-icon icon="three-dots-vertical"></b-icon>
                        </a>
                        <div class="dropdown-menu action-dropdown-menu" :aria-labelledby="'actionDropdown-log-' + log.id">
                          <b-button-group>
                            <b-button variant="outline-secondary" @click="viewLogDetails(log)">
                              <b-icon icon="eye"></b-icon>
                              View details
                            </b-button>
                          </b-button-group>
                        </div>
                      </template>
                      <span v-else class="text-muted small">N/A</span>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div v-if="activityLogs.length == 0" class="px-3 py-3 no-result-cell">No Result Found!</div>
            <div v-if="activityLogs.length > 0" class="px-3 mt-3 d-flex justify-content-between align-items-center">
              <ul class="pagination b-pagination mb-0 mt-1">
                <li class="page-item disabled m-2">View</li>
                <li class="page-item disabled">
                  <b-form-select v-model="log_temp_length" :options="log_length_options" @change="log_pagination.currentPage = 1"></b-form-select>
                </li>
                <li class="page-item disabled m-2">per page. Total {{activityLogs.length}} logs found.</li>
              </ul>
              <b-pagination
                v-model="log_pagination.currentPage"
                :total-rows="activityLogs.length"
                :per-page="log_temp_length"
                prev-text="Previous"
                next-text="Next"
                first-number
                last-number
                class="mb-0 mt-1"
              ></b-pagination>
            </div>
          </div>
        </b-tab>
      </b-tabs>
      </div>


    <b-modal id="bv-modal-overtime-policy" :title="modalTitle" size="lg" hide-footer dialog-class="w-1200">
      <div class="position-relative p-3">

        <b-form @submit.stop.prevent="onSubmit">
          <input type="hidden" v-model="fdata.id" name="id">

          <!-- First Row: Inputs -->
          <div class="row">
            <div class="col-sm-4">
              <b-form-group id="name-group" label="Policy Name" label-for="name" class="required-field">
                <b-form-input id="name" name="name" v-model="fdata.name" v-validate="{ required: true, min: 3 , alpha_spaces: true }"
                              :state="validateState('name')" aria-describedby="name-feedback" data-vv-as="Name"></b-form-input>
                <b-form-invalid-feedback id="name-feedback"> {{veeErrors.first('name')}} </b-form-invalid-feedback>
              </b-form-group>
            </div>
            <div class="col-sm-4">
              <b-form-group id="min_minute-group" label="Minimum Requirement for OT (mins)" label-for="min_minute" class="required-field">
                <b-form-input id="min_minute" name="min_minute" v-model="fdata.min_minute" v-validate="{ min_value:10 , max_value:60}"
                              :state="validateState('min_minute')" aria-describedby="min_minute-feedback" data-vv-as="Min Requirement for OT"></b-form-input>
                <b-form-invalid-feedback id="min_minute-feedback" class="d-block">
                  {{ veeErrors.first('min_minute') }}
                </b-form-invalid-feedback>
              </b-form-group>
            </div>
            <div class="col-sm-4">
              <b-form-group id="max_hours-group" label="Maximum Allowed OT (hrs)" label-for="max_hours" class="required-field" >
                <b-input-group class="rounded" style="border: 1px solid #004d40;">
                  <b-form-input class="border-0" id="max_hours" name="max_hours" v-model="fdata.max_hours"
                                v-validate="{ min_value:1 , max_value:60}"
                                :state="validateState('max_hours')" aria-describedby="max_hours-feedback"
                                data-vv-as="Max Allowed OT"></b-form-input>
                  <b-input-group-append>
                    <label class="input-group-text bg-white" style="border: none; border-right: 1px solid #004242;">per</label>
                    <b-form-select
                        id="max_limit_type"
                        name="max_limit_type"
                        v-model="fdata.max_limit_type"
                        :options="max_limit_type_options"
                        v-validate="{ required: true }"
                        :state="validateState('max_limit_type')"
                        class="border-0"
                    ></b-form-select>
                  </b-input-group-append>
                </b-input-group>
                <b-form-invalid-feedback id="max_hours-feedback" class="d-block">
                  {{ veeErrors.first('max_hours') }}
                </b-form-invalid-feedback>
              </b-form-group>
            </div>
          </div>

          <!-- Alert for Period info -->
          <div class="row my-2">
            <div class="col-12">
              <b-alert show variant="info" class="py-2 px-3 m-0 rounded">
                <b-icon icon="info-circle" class="mr-1"></b-icon> This policy period runs from the {{ ot_day == '31' ? '01' : String(Number(ot_day) + 1).padStart(2, "0") }}th of the {{ot_day != '31' ? 'previous' : 'current' }} month to the {{ ot_day }}th of the current month. You can change it in General Settings.
              </b-alert>
            </div>
          </div>

          <!-- Second Row: Settings Columns -->
          <div class="row mt-3 mb-4">
            <!-- Left Column -->
            <div class="col-md-6">
              <!-- For OT Calculation Box -->
              <div class="card border-0 radius-8 overflow-hidden">
                <div class="card-header text-white font-weight-bold py-2 px-3" style="background-color: #0056b3; font-size: 14px;">
                  For OT Calculation
                </div>
                
                <div class="card-body p-3 susd">
                <!-- Fixed Amount Row -->
                  <div class="d-flex flex-row justify-content-between align-items-center mb-2 pb-2 border-bottom">
                    <span class="roster-toggle-label">Fixed Amount Per Day</span>
                    <div class="d-flex align-items-center justify-content-end">
                      <!-- Input for Fixed Amount -->
                        <b-form-checkbox class="roster-small-switch" v-model="fdata.ot_on" name="ot_on" :value="1" :unchecked-value="0" switch></b-form-checkbox>                      
                      </div>

                      </div>


                      <div v-if="fdata.ot_on == 1" class="w-100 mr-2">
                      <b-input-group append="Taka">
                        <b-form-input id="fixed_amount" name="fixed_amount" v-model="fdata.fixed_amount" v-validate="{ min_value:10 , max_value:100000}" :state="validateState('fixed_amount')" aria-describedby="fixed_amount-feedback" data-vv-as="OT Fixed Amount"></b-form-input>
                      </b-input-group>
                        <b-form-invalid-feedback id="fixed_amount-feedback" class="d-block">{{ veeErrors.first('fixed_amount') }}</b-form-invalid-feedback>
                      </div>
                      <!-- Calculate on Salary Row -->
                      <div v-if="fdata.ot_on != 1" class="d-flex flex-row justify-content-between align-items-center pb-2">
                      <div class="d-flex align-items-center">
                      <span class="mr-2 w-200 roster-toggle-label">Calculate on</span>
                      <b-form-select id="calculate_on" name="calculate_on" v-model="fdata.calculate_on" :options="calculate_on_options" size="sm" :disabled="fdata.ot_on == 1"></b-form-select>
                      <span class="ml-2 roster-toggle-label">Salary</span>
                    </div>


                  </div>
                  <div class="d-flex flex-row justify-content-between align-items-center mb-2 pt-2 border-top">
                    <span class="roster-toggle-label">Slab Wise (regular working day extra hours)</span>
                    <div class="d-flex align-items-center justify-content-end">
                        <b-form-checkbox class="roster-small-switch" v-model="fdata.slab" name="slab" :value="1" :unchecked-value="0" switch @change="onSlabToggle"></b-form-checkbox>              
                      </div>

                  </div>
                </div>
              </div>
            </div>

            <!-- Right Column -->
            <div class="col-md-6 public-info-last">
              <div class="border-0">
                <!-- Switch 1 -->
                <div class="d-flex flex-row justify-content-between align-items-center py-2 mb-2 border-bottom">
                  <span class="roster-toggle-label">Calculate From Exact Punch-Time</span>
                  <b-form-checkbox class="roster-small-switch" v-model="fdata.from_settings_in" name="from_settings_office_endtime" :value="1" :unchecked-value="0" switch></b-form-checkbox>
                </div>
                <!-- Switch 2 -->
                <div class="d-flex flex-row justify-content-between align-items-center py-2 mb-2 border-bottom">
                  <span class="roster-toggle-label">Calculate OT Before Schedule Start</span>
                  <b-form-checkbox class="roster-small-switch" v-model="fdata.cumu_over_under" name="cumu_over_under" :value="1" :unchecked-value="0" switch></b-form-checkbox>
                </div>
                <div class="row pt-1">
                  <div class="col-12">
                    <b-form-group label="Hours Required On Week Off / Holidays" label-size="sm" class="mb-0">
                      <b-form-input v-model="fdata.credit_hour_holiday" size="sm" v-validate="{ decimal:2 }" :state="validateState('credit_hour_holiday')"></b-form-input>
                    </b-form-group>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- Table Section -->
          <div class="table-responsive mt-3">
            <table class="table table-bordered text-center align-middle">
                <thead>
                    <tr class="table-head">
                        <th></th>
                        <th class="text-left">Considered Day Type</th>
                        <th>Campensatory Leave Ratio</th>
                        <th>Overtime Pay Ratio</th>
                    </tr>
                </thead>
                <tbody>
                <!-- Row 1 -->
                <tr class="hover-bg">
                    <td class="checkbox-col">
                        <input type="checkbox" class="justify-content-center" :disabled="fdata.slab == 1"
                            :checked="fdata.rate_regular_leave > 0 || fdata.rate_regular_salary > 0"
                            @change="
                                fdata.rate_regular_leave = $event.target.checked ? (fdata.rate_regular_leave > 0 ? fdata.rate_regular_leave : 1) : 0;
                                fdata.rate_regular_salary = $event.target.checked ? (fdata.rate_regular_salary > 0 ? fdata.rate_regular_salary : 1) : 0;
                            "
                        >
                    </td>
                    <td class="text-left font-weight-500 date-0">Consider extra work hour of regular working day as OT</td>
                    <td>
                    <!-- <b-form-input v-model="fdata.rate_regular_leave" class="text-center font-weight-bold mx-auto" size="sm"></b-form-input> -->
                    </td>
                    <td>
                    <div v-if="fdata.slab == 1" class="bg-light border rounded py-1 px-2 font-weight-bold text-muted text-center">Slab wise (view only)</div>
                    <b-form-input v-else v-model="fdata.rate_regular_salary" class="text-center font-weight-bold mx-auto" size="sm"></b-form-input>
                    </td>
                </tr>
                <!-- Row 2 (Weekend) -->
                <tr class="hover-bg">
                    <td class="checkbox-col">
                        <input type="checkbox" class="justify-content-center"
                            :checked="fdata.rate_weekend_leave > 0 || fdata.rate_weekend_salary > 0"
                            @change="
                                fdata.rate_weekend_leave = $event.target.checked ? (fdata.rate_weekend_leave > 0 ? fdata.rate_weekend_leave : 1) : 0;
                                fdata.rate_weekend_salary = $event.target.checked ? (fdata.rate_weekend_salary > 0 ? fdata.rate_weekend_salary : 1) : 0;
                            "
                        >
                    </td>
                    <td class="text-left font-weight-500 date-0">Count Weekend as OT</td>
                    <td>
                    <b-form-input v-model="fdata.rate_weekend_leave" class="text-center font-weight-bold mx-auto" size="sm"></b-form-input>
                    </td>
                    <td>
                    <b-form-input v-model="fdata.rate_weekend_salary" class="text-center font-weight-bold mx-auto" size="sm"></b-form-input>
                    </td>
                </tr>
                <!-- Row 3 (Holiday) -->
                <tr class="hover-bg">
                    <td class="checkbox-col">
                        <input type="checkbox" class="justify-content-center"
                            :checked="fdata.rate_holiday_leave > 0 || fdata.rate_holiday_salary > 0"
                            @change="
                                fdata.rate_holiday_leave = $event.target.checked ? (fdata.rate_holiday_leave > 0 ? fdata.rate_holiday_leave : 1) : 0;
                                fdata.rate_holiday_salary = $event.target.checked ? (fdata.rate_holiday_salary > 0 ? fdata.rate_holiday_salary : 1) : 0;
                            "
                        >
                    </td>
                    <td class="text-left font-weight-500 date-0">Count Holiday as OT</td>
                    <td>
                    <b-form-input v-model="fdata.rate_holiday_leave" class="text-center font-weight-bold mx-auto" size="sm"></b-form-input>
                    </td>
                    <td>
                    <b-form-input v-model="fdata.rate_holiday_salary" class="text-center font-weight-bold mx-auto" size="sm"></b-form-input>
                    </td>
                </tr>
                </tbody>
            </table>
        </div>

          <!-- Slab-wise OT for Regular Day -->
          <div v-if="fdata.slab == 1" class="approval-container p-3 mt-3 mb-3">
            <div class="d-flex justify-content-between align-items-start mb-2">
              <div>
                <h6 class="font-weight-bold mb-0">OT Slabs &middot; Regular Working Day</h6>
                <small class="text-muted">Extra hours after the scheduled shift are paid slab by slab.</small>
              </div>
              <b-button size="sm" variant="secondary" class="custom-wizard-btn" :disabled="lastSlabIsRemaining" @click="addSlab()">
                + Add Slab
              </b-button>
            </div>

            <div class="table-responsive">
              <table class="table table-bordered align-middle mb-2">
                <thead>
                  <tr class="table-head">
                    <th style="width: 60px;">Slab</th>
                    <th class="text-center">From (hr)</th>
                    <th class="text-center">To (hr)</th>
                    <th class="text-center">OT Multiplier (&times;)</th>
                    <th>Applies To</th>
                    <th style="width: 60px;"></th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(row, i) in fdata.slabs" :key="i">
                    <td class="font-weight-bold align-middle">{{ i + 1 }}</td>
                    <td>
                      <b-form-input v-model="row.from_hr" size="sm" class="text-center font-weight-bold" type="number" step="0.5" min="0"
                                    :state="slabFromValid(i) ? null : false"></b-form-input>
                    </td>
                    <td>
                      <div class="d-flex align-items-center">
                        <div v-if="row.is_remaining" class="bg-light border rounded py-1 px-2 font-weight-bold text-primary text-center flex-grow-1">Remaining</div>
                        <b-form-input v-else v-model="row.to_hr" size="sm" class="text-center font-weight-bold" type="number" step="0.5" min="0"
                                      :state="slabRowValid(row) ? null : false" @input="syncNextFrom(i)"></b-form-input>
                        <label v-if="i == fdata.slabs.length - 1" class="d-flex align-items-center mb-0 ml-2 small text-nowrap">
                          <input type="checkbox" v-model="row.is_remaining" class="mr-1"> Rem.
                        </label>
                      </div>
                    </td>
                    <td>
                      <b-form-input v-model="row.multiplier" size="sm" class="text-center font-weight-bold" type="number" step="0.01" min="0"
                                    :state="row.multiplier === '' || Number(row.multiplier) < 0 ? false : null"></b-form-input>
                    </td>
                    <td class="align-middle small">{{ slabAppliesTo(row) }}</td>
                    <td class="text-center align-middle">
                      <b-button size="sm" variant="outline-danger" :disabled="fdata.slabs.length == 1" @click="removeSlab(i)">
                        <b-icon icon="trash"></b-icon>
                      </b-button>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div v-if="slabError" class="invalid-feedback d-block mb-1">{{ slabError }}</div>
            <small v-else-if="slabExample" class="text-muted">{{ slabExample }}</small>
          </div>


            <div v-if="fdata.rate_regular_leave > 0 || fdata.rate_regular_salary > 0 || fdata.rate_weekend_leave > 0 || fdata.rate_weekend_salary > 0 || fdata.rate_holiday_leave > 0 || fdata.rate_holiday_salary > 0" class="approval-container p-3 mt-3 mb-3 table-responsive">
              <h5 class="text-center mb-3 modal-title employee-count-number bg-transparent w-100">
                Payment policy
              </h5>
              <table class="table table-bordered text-center align-middle">
                <thead class="table-head">
                  <th></th>
                  <th v-if="fdata.rate_regular_leave > 0 || fdata.rate_regular_salary > 0">Regular Day</th>
                  <th v-if="fdata.rate_weekend_leave > 0 || fdata.rate_weekend_salary > 0">Weekend</th>
                  <th v-if="fdata.rate_holiday_leave > 0 || fdata.rate_holiday_salary > 0">Holiday</th>
                </thead>
                <tbody>
                  <tr>
                    <td>Specified Days(0 for Days In Month)</td>
                    <td v-if="fdata.rate_regular_leave > 0 || fdata.rate_regular_salary > 0">
                      <b-form-group class="mb-0" label-for="regular_days"
                        :state="validateState('regular_days')">
                        <b-form-input id="regular_days" v-model="fdata.regular_days" v-validate="'required|numeric|min_value:0'"
                          name="regular_days" type="text" min="0" :state="validateState('regular_days')" />
                        <b-form-invalid-feedback>{{ veeErrors.first('regular_days') }}</b-form-invalid-feedback>
                      </b-form-group>
                    </td>
                    <td v-if="fdata.rate_weekend_leave > 0 || fdata.rate_weekend_salary > 0">
                      <b-form-group class="mb-0" label-for="weekend_days"
                        :state="validateState('weekend_days')">
                        <b-form-input id="weekend_days" v-model="fdata.weekend_days" v-validate="'required|numeric|min_value:0'"
                          name="weekend_days" type="text" min="0" :state="validateState('weekend_days')" />
                        <b-form-invalid-feedback>{{ veeErrors.first('weekend_days') }}</b-form-invalid-feedback>
                      </b-form-group>
                    </td>
                    <td v-if="fdata.rate_holiday_leave > 0 || fdata.rate_holiday_salary > 0">
                      <b-form-group class="mb-0" label-for="holiday_days"
                        :state="validateState('holiday_days')">
                        <b-form-input id="holiday_days" v-model="fdata.holiday_days" v-validate="'required|numeric|min_value:0'"
                          name="holiday_days" type="text" min="0" :state="validateState('holiday_days')" />
                        <b-form-invalid-feedback>{{ veeErrors.first('holiday_days') }}</b-form-invalid-feedback>
                      </b-form-group>
                    </td>
                  </tr>
                  <tr>
                    <td>Custom Hours(0 for Actual Duty Time)</td>
                    <td v-if="fdata.rate_regular_leave > 0 || fdata.rate_regular_salary > 0">
                      <b-form-group class="mb-0" label-for="regular_hour"
                        :state="validateState('regular_hour')">
                        <b-form-input id="regular_hour" v-model="fdata.regular_hour" v-validate="'required|numeric|min_value:0'"
                          name="regular_hour" type="text" min="0" :state="validateState('regular_hour')" />
                        <b-form-invalid-feedback>{{ veeErrors.first('regular_hour') }}</b-form-invalid-feedback>
                      </b-form-group>
                    </td>
                    <td v-if="fdata.rate_weekend_leave > 0 || fdata.rate_weekend_salary > 0">
                      <b-form-group class="mb-0" label-for="weekend_hour"
                        :state="validateState('weekend_hour')">
                        <b-form-input id="weekend_hour" v-model="fdata.weekend_hour" v-validate="'required|numeric|min_value:0'"
                          name="weekend_hour" type="text" min="0" :state="validateState('weekend_hour')" />
                        <b-form-invalid-feedback>{{ veeErrors.first('weekend_hour') }}</b-form-invalid-feedback>
                      </b-form-group>
                    </td>
                    <td v-if="fdata.rate_holiday_leave > 0 || fdata.rate_holiday_salary > 0">
                      <b-form-group class="mb-0" label-for="holiday_hour"
                        :state="validateState('holiday_hour')">
                        <b-form-input id="holiday_hour" v-model="fdata.holiday_hour" v-validate="'required|numeric|min_value:0'"
                          name="holiday_hour" type="text" min="0" :state="validateState('holiday_hour')" />
                        <b-form-invalid-feedback>{{ veeErrors.first('holiday_hour') }}</b-form-invalid-feedback>
                      </b-form-group>
                    </td>
                  </tr>
                </tbody>
              </table>
          </div>

          <!-- Tax Status Section -->
          <div class="approval-container p-3 mt-3 mb-3">
            <h5 class="text-center mb-3 modal-title employee-count-number bg-transparent w-100">
              Tax Status
            </h5>
            <div class="row text-center border mx-4 rounded">
              <div class="col-6 py-4 border-right">
                <b-form-radio v-model="fdata.taxable" name="taxable" :value="1" size="lg" class="d-inline-block font-weight-bold">
                  Taxable
                </b-form-radio>
              </div>
              <div class="col-6 py-4">
                <b-form-radio v-model="fdata.taxable" name="taxable" :value="0" size="lg" class="d-inline-block font-weight-bold">
                  Non-Taxable
                </b-form-radio>
              </div>
            </div>

            <!-- Sub-options for Taxable -->
            <template v-if="fdata.taxable == 1">
                <b-form-group label="" class="leave-attendance-legends col-12 text-center mt-4">
                    <b-form-radio-group
                        class="leave-attendance-btns w-75"
                        v-model="fdata.tax_over_fy"
                        @input="fdata.deduct_tax_upfront = Math.abs(1 - fdata.tax_over_fy)"
                        buttons button-variant="outline-secondary">
                        <b-form-radio :value="1"><span>Allocate Tax over the Fiscal Year</span></b-form-radio>
                        <b-form-radio :value="0"><span>Deduct Effective Tax up-front</span></b-form-radio>
                    </b-form-radio-group>
                </b-form-group>
            </template>
          </div>

          <!-- Submit / Reset Buttons -->
          <div class="d-flex justify-content-center mt-5">
            <b-button variant="primary" type="submit">Submit</b-button>
            <b-button class="ml-3 custom-wizard-btn" @click="resetForm()">Reset</b-button>
          </div>
        </b-form>
      </div>
    </b-modal>


    <!-- Log Details Modal -->
    <b-modal id="bv-modal-log-details" hide-footer title="Policy Log Details" size="lg">
      <div v-if="selectedLog" class="p-3">
        <div class="row mb-3 pb-2 border-bottom">
          <div class="col-sm-4"><strong>Policy Name:</strong></div>
          <div class="col-sm-8">{{ selectedLog.policy_name }}</div>
        </div>
        <div class="row mb-3 pb-2 border-bottom">
          <div class="col-sm-4"><strong>Description:</strong></div>
          <div class="col-sm-8">{{ selectedLog.action }}d By {{ selectedLog.activity_by }} at {{ formatDateTime(selectedLog.created_at) }}</div>
        </div>
        
        <div v-if="parsedDetails" class="mt-4">
          <h5 class="font-weight-bold mb-3">Configured Rules:</h5>
          <div class="ibox p-3 mb-3">
            <div class="row">
              <div class="col-md-6 mb-2">
                <strong>Minimum OT Requirement:</strong> {{ parsedDetails.min_minute }} minutes
              </div>
              <div class="col-md-6 mb-2">
                <strong>Maximum Allowed OT:</strong> {{ parseInt(parsedDetails.max_hours) }} hrs per {{ parsedDetails.max_limit_type == 1 ? 'month' : 'day' }}
              </div>
              <div class="col-md-6 mb-2">
                <strong>OT Calculation Type:</strong> {{ parsedDetails.ot_on == 1 ? 'Fixed Amount' : 'Salary Based' }}
              </div>
              <div class="col-md-6 mb-2" v-if="parsedDetails.ot_on == 1">
                <strong>Fixed Amount:</strong> {{ parsedDetails.fixed_amount }} Taka
              </div>
              <div class="col-md-6 mb-2" v-else>
                <strong>Calculate on:</strong> {{ parsedDetails.calculate_on == 1 ? 'Gross' : 'Basic' }} Salary
              </div>
              <div class="col-md-6 mb-2">
                <strong>Clock Settings:</strong> {{ parsedDetails.from_settings_in == 1 ? 'Exact Punch-Time' : 'Office Shift Time' }}
              </div>
              <div class="col-md-6 mb-2">
                <strong>OT Range:</strong> {{ parsedDetails.cumu_over_under == 1 ? 'Before Clock-In & After Clock-Out' : 'After Clock-Out Only' }}
              </div>
              <div class="col-md-6 mb-2">
                <strong>Required Hours (Week-off/Holidays):</strong> {{ parsedDetails.credit_hour_holiday }} hrs
              </div>
              <div class="col-md-6 mb-2">
                <strong>Tax Status:</strong> {{ parsedDetails.taxable == 1 ? 'Taxable' : 'Non-Taxable' }}
              </div>
              <div class="col-md-6 mb-2" v-if="parsedDetails.taxable == 1">
                <strong>Tax Deduction:</strong> {{ parsedDetails.tax_over_fy == 1 ? 'Allocate over Fiscal Year' : 'Deduct Effective up-front' }}
              </div>
            </div>

            <h6 class="font-weight-bold text-primary mt-3 pb-2">Ratios:</h6>
            <table class="table dataTable border">
              <thead class="table-head">
                <tr class="table-head">
                  <th>Day Type</th>
                  <th>Compensatory Leave Ratio</th>
                  <th>Overtime Pay Ratio</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>Regular Work Day</td>
                  <td>-</td>
                  <td class="text-center font-weight-bold">{{ parsedDetails.rate_regular_salary }}</td>
                </tr>
                <tr>
                  <td>Weekend</td>
                  <td class="text-center font-weight-bold">{{ parsedDetails.rate_weekend_leave }}</td>
                  <td class="text-center font-weight-bold">{{ parsedDetails.rate_weekend_salary }}</td>
                </tr>
                <tr>
                  <td>Holiday</td>
                  <td class="text-center font-weight-bold">{{ parsedDetails.rate_holiday_leave }}</td>
                  <td class="text-center font-weight-bold">{{ parsedDetails.rate_holiday_salary }}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </b-modal>


  </div>
</template>
<script>
export default {

  props: [],
  data() {
    let sortOrders = {};
    let columns = [
      {label: 'Policy Name', name: 'name', sort: true},
      {label: 'Taxable', name: 'taxable'},
      {label: 'Min Countable Time (mins)', name: 'min_minute'},
      {label: 'Max Allowed OT (hrs)', name: 'max_hours'},
    ];
    columns.forEach((column) => {
      sortOrders[column.name] = -1;
    });

    return {
      temp_length: 20,
      length_options:
          [
              { value: 20, text: "20" },
              { value: 50, text: "50" },
              { value: 100, text: "100" }
          ],
      blankmsg: 'Fetching data..',
      datalist: [],
      leavetypes: [],
      showoverlay: false,
      ot_day: 0,
      fdata: {
          id: null,
        leave_type_id: 0,
          name: '',
        max_limit_type: 0,
          min_minute: 0,
          max_hours: 0,
          ot_on: 0,
          fixed_amount: 0,
          calculate_on: 0,
          from_settings_in: 1,
          cumu_over_under: 1,
          daily_ot: 1,
        leave_in_lieu: 1,
          cumu_ot: 1,
        credit_hour_holiday: 0,
        credit_hour_lieu: 0,

          rate_regular_leave: 0,
          rate_regular_salary: 0,

          rate_weekend_leave: 0,
          rate_weekend_salary: 0,

          rate_holiday_leave: 0,
          rate_holiday_salary: 0,

          taxable: 1,
          tax_over_fy: 1,
          deduct_tax_upfront: 0,
          regular_days: 0,
          regular_hour: 0,
          weekend_days: 0,
          weekend_hour: 0,
          holiday_days: 0,
          holiday_hour: 0,
          slab: 0,
          slabs: []
        },
      search: '',
      columns: columns,
      sortKey: 'name',
      sortOrders: sortOrders,
      length: 10,
      pagination: {currentPage: 1, total: '', nextPage: '', prevPage: '', from: '', to: '', pages: 1},
      yes_no: [
        {value: "0", text: "No"},
        {value: "1", text: "Yes"}
      ],
      calculate_on_options: [
        {value: "0", text: "Basic"},
        {value: "1", text: "Gross"}
      ],
      max_limit_type_options: [
        { value: 0, text: 'Daily' },
        { value: 1, text: 'Monthly' }
      ],
      timezones: [],
      modalTitle: 'Overtime Policy',
      activityLogs: [],
      selectedLog: null,
      log_temp_length: 10,
      log_length_options: [
        { value: 10, text: "10" },
        { value: 20, text: "20" },
        { value: 50, text: "50" },
        { value: 100, text: "100" }
      ],
      log_pagination: { currentPage: 1 },
    }
  },
  methods: {
    resetForm() {
      this.fdata = {
        id: null,
        name: '',
        min_minute: 0,
        leave_type_id: 0,
        max_limit_type: 0,
        credit_hour_holiday: 0,
        credit_hour_lieu: 0,
        max_hours: 0,
        ot_on: 0,
        fixed_amount: 0,
        calculate_on: 0,
        from_settings_in: 1,
        cumu_over_under: 1,
        daily_ot: 1,
        leave_in_lieu: 1,
        cumu_ot: 1,

        rate_regular_leave: 0,
        rate_regular_salary: 0,

        rate_weekend_leave: 0,
        rate_weekend_salary: 0,

        rate_holiday_leave: 0,
        rate_holiday_salary: 0,

        taxable: 1,
        tax_over_fy: 1,
        deduct_tax_upfront: 0,
        regular_days: 0,
        regular_hour: 0,
        weekend_days: 0,
        weekend_hour: 0,
        holiday_days: 0,
        holiday_hour: 0,
        slab: 0,
        slabs: []
      };

      this.$nextTick(() => {
        this.$validator.reset();
      });
    },
    addNew() {
      this.modalTitle = 'Create Overtime Policy';
      this.resetForm();
      this.$bvModal.show('bv-modal-overtime-policy');
    },


    getCompanyLeaveSettings:function()
    {
      if(!this.checkNet()) return false;
      axios.get(this.$api_url+'/leave-attendance/company/leave/settings').then(function(response){

        if(response.data.length != 0)
        {
          this.ot_day = response.data.ot_day;
        }

      }.bind(this));

    },


    //
    getData: function () {
      if (!this.checkNet()) return false;
      axios.get(this.$api_url + '/leave-attendance/overtime/policy/index').then(function (response) {

        this.datalist = response.data;
        if (this.datalist.length == 0)
          this.blankmsg = "Nothing found.";
      }.bind(this)).catch((error) => {
        this.serverError(error);
      });
    },
    editData: function (x) {
      let data = this.datalist.find((item) => item.id == x);
      for(let [k,v] of Object.entries(data)){
        this.fdata[k] = v;
      }
      let slabs = data.slabs;
      if (typeof slabs === 'string') {
        try { slabs = JSON.parse(slabs); } catch (e) { slabs = []; }
      }
      this.fdata.slab = Number(data.slab) === 1 ? 1 : 0;
      this.fdata.slabs = Array.isArray(slabs) ? slabs.map(s => ({
        from_hr: Number(s.from_hr) || 0,
        to_hr: s.to_hr === null || s.to_hr === undefined ? '' : s.to_hr,
        multiplier: s.multiplier,
        is_remaining: !!s.is_remaining
      })) : [];
      this.modalTitle = 'Edit Overtime Policy';
      this.$bvModal.show('bv-modal-overtime-policy');

    },
    deleteData(id) {
      if (!this.checkNet()) return false;
      let currentObj = this;

      this.$bvModal.msgBoxConfirm('Please confirm that you want to delete.', {
        title: 'Please Confirm',
        size: 'sm',
        buttonSize: 'sm',
        okVariant: 'primary',
        okTitle: 'Yes',
        cancelTitle: 'Cancel',
        bodyClass: "text-center",
        footerClass: "p-2 border-0 d-flex justify-content-center",
        hideHeaderClose: false,
        centered: true
      })
          .then(value => {
            if (value) {
              let formData = new FormData();
              formData.append('id', id);
              axios.post(this.$api_url + '/leave-attendance/overtime/policy/delete', formData).then(function (response) {
                this.getData();
                this.getActivityLogs();
                this.showoverlay = false;

              }.bind(this))
                  .catch(function (error) {

                    currentObj.showoverlay = false;
                    currentObj.serverError(error);
                  });
            }
          })
      ;
    },


    getLeaveTypes: function()
    {
      if(!this.checkNet()) return false;
      axios.get(this.$api_url+'/leave-attendance/leave/types' , {

      }).then(function(response){

        this.leavetypes = response.data;
      }.bind(this));
    },
    onSubmit(e) {
      if (!this.checkNet()) return false;

      this.$validator.validateAll().then(result => {
        if (!result) {
          return;
        }
        if (this.fdata.slab == 1 && this.slabError) {
          this.$bvToast.toast(this.slabError, { title: 'Invalid Slab', variant: 'danger', solid: true });
          return;
        }
        this.showoverlay = true;

        e.preventDefault();

        let formData = new FormData();

        for (let [key, value] of Object.entries(this.fdata)) {
          if (key === 'slabs') continue;
          var nm = `${key}`;
          var fval = `${value}`;
          formData.append(nm, fval);
          //console.log(`${key}: ${value}`);
        }
        const useSlab = this.fdata.slab == 1 && this.fdata.rate_regular_salary > 0;
        formData.set('slab', useSlab ? 1 : 0);
        formData.append('slabs', JSON.stringify(useSlab ? this.fdata.slabs.map(s => ({
          from_hr: Number(s.from_hr),
          to_hr: s.is_remaining ? null : Number(s.to_hr),
          multiplier: Number(s.multiplier),
          is_remaining: s.is_remaining ? 1 : 0
        })) : []));

        var url = this.$api_url + '/leave-attendance/overtime/policy/save';

        axios.post(url, formData)
            .then(function (response) {
              this.getData();
              this.getActivityLogs();
              this.$bvToast.toast('Saved!', {
                title: `Success`,
                variant: 'success',
                solid: true
              });
              this.showoverlay = false;
              this.resetForm();
              this.$bvModal.hide('bv-modal-overtime-policy');

            }.bind(this))
            .catch((error) => {
              this.showoverlay = false;
              this.serverError(error);
            });
      });
    },

    onSlabToggle(val) {
      if (val != 1) return;
      // slabs only apply when regular day OT is considered
      if (!(this.fdata.rate_regular_salary > 0)) this.fdata.rate_regular_salary = 1;
      if (this.fdata.slabs.length == 0) this.addSlab();
    },
    // when a slab's "To" changes, the next slab starts from it
    syncNextFrom(i) {
      const next = this.fdata.slabs[i + 1];
      if (next) next.from_hr = this.fdata.slabs[i].to_hr;
    },
    slabFromValid(i) {
      const row = this.fdata.slabs[i];
      if (row.from_hr === '' || Number(row.from_hr) < 0) return false;
      if (i == 0) return true;
      return Number(row.from_hr) >= Number(this.fdata.slabs[i - 1].to_hr);
    },
    slabAppliesTo(row) {
      const from = Number(row.from_hr) || 0;
      const mul = row.multiplier === '' ? '?' : Number(row.multiplier);
      if (row.is_remaining) return `Remaining hours after ${from} hrs → ${mul}× OT`;
      if (row.to_hr === '' || Number(row.to_hr) <= from) return '-';
      const to = Number(row.to_hr);
      if (from == 0) return `First ${to} hrs → ${mul}× OT`;
      if (to - from == 1) return `Hour ${to} → ${mul}× OT`;
      return `Hours ${from + 1}–${to} → ${mul}× OT`;
    },
    addSlab() {
      const last = this.fdata.slabs[this.fdata.slabs.length - 1];
      this.fdata.slabs.push({
        from_hr: last ? (Number(last.to_hr) || 0) : 0,
        to_hr: '',
        multiplier: this.fdata.rate_regular_salary || 1,
        is_remaining: false
      });
    },
    removeSlab(i) {
      this.fdata.slabs.splice(i, 1);
      this.syncSlabs();
    },
    // keep slabs contiguous: each slab starts where the previous one ends
    syncSlabs() {
      this.fdata.slabs.forEach((s, i) => {
        s.from_hr = i == 0 ? 0 : (Number(this.fdata.slabs[i - 1].to_hr) || 0);
        if (i < this.fdata.slabs.length - 1) s.is_remaining = false;
      });
    },
    slabRowValid(row) {
      if (row.is_remaining) return true;
      return row.to_hr !== '' && Number(row.to_hr) > Number(row.from_hr);
    },

    getActivityLogs() {
      if (!this.checkNet()) return false;
      axios.get(this.$api_url + '/leave-attendance/overtime/policy/activity-log')
        .then((response) => {
          this.activityLogs = response.data;
        })
        .catch((error) => {
          this.serverError(error);
        });
    },
    viewLogDetails(log) {
      this.selectedLog = log;
      this.$bvModal.show('bv-modal-log-details');
    },
    formatDateTime(str) {
      if (!str) return '';

      const d = new Date(str);
      const pad = value => String(value).padStart(2, '0');

      return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())} ${pad(d.getHours())}:${pad(d.getMinutes())}:${pad(d.getSeconds())}`;
    },

  },
  created: function () {
    this.getData();
    this.getActivityLogs();
    this.getLeaveTypes();
    this.getCompanyLeaveSettings();
    Fire.$on('reloadData', () => {
      this.getData();
      this.getActivityLogs();
    });
  },


  computed:
      {
        filteredData() {
          let filtered_list = this.datalist;
          if (this.search) {
            filtered_list = filtered_list.filter((row) => {
              return Object.keys(row).some((key) => {
                return String(row[key]).toLowerCase().indexOf(this.search.toLowerCase()) > -1;
              })
            });

            if (filtered_list.length == 0)
              this.blankmsg = "Nothing found.";
          }

          let sortKey = this.sortKey;
          let order = this.sortOrders[sortKey] || 1;
          if (sortKey) {
            filtered_list = filtered_list.slice().sort((a, b) => {
                  let index = this.getIndex(this.columns, 'name', sortKey);
                  a = String(a[sortKey]).toLowerCase();
                  b = String(b[sortKey]).toLowerCase();
                  if (this.columns[index].type && this.columns[index].type === 'date') {
                    return (a === b ? 0 : new Date(a).getTime() > new Date(b).getTime() ? 1 : -1) * order;
                  } else if (this.columns[index].type && this.columns[index].type === 'number') {
                    return (+a === +b ? 0 : +a > +b ? 1 : -1) * order;
                  } else {
                    return (a === b ? 0 : a > b ? 1 : -1) * order;
                  }
                }
            );
          }

          return filtered_list;
        },
        paginatedData() {
          return this.paginate(this.filteredData, this.length, this.pagination.currentPage);
        },
        calculateWorkingHours() {
          if (!this.fdata.clockin || !this.fdata.clockout) {
            this.fdata.work_time = 0;
            return this.fdata.work_time;
          }

          const [inHours, inMinutes] = this.fdata.clockin.split(":").map(Number);
          const [outHours, outMinutes] = this.fdata.clockout.split(":").map(Number);

          // Create Date objects
          const clockInDate = new Date(0, 0, 0, inHours, inMinutes);
          const clockOutDate = new Date(0, 0, 0, outHours, outMinutes);

          // Calculate the difference in minutes
          const workedMinutes = (clockOutDate - clockInDate) / (1000 * 60);


          if (this.fdata.break_time > 0) {
            // Subtract the break time
            this.fdata.work_time = workedMinutes - this.fdata.break_time;
          } else {
            this.fdata.work_time = workedMinutes;
          }

        },
        parsedDetails() {
          if (!this.selectedLog || !this.selectedLog.details) return null;
          try {
            const parsed = typeof this.selectedLog.details === 'string'
              ? JSON.parse(this.selectedLog.details)
              : this.selectedLog.details;
            return parsed.policies || parsed;
          } catch (e) {
            return null;
          }
        },
        lastSlabIsRemaining() {
          const last = this.fdata.slabs[this.fdata.slabs.length - 1];
          return !!(last && last.is_remaining);
        },
        slabError() {
          if (this.fdata.slab != 1) return '';
          if (!this.fdata.slabs.length) return 'Add at least one slab.';
          for (let i = 0; i < this.fdata.slabs.length; i++) {
            const s = this.fdata.slabs[i];
            if (!this.slabFromValid(i)) return `Slab ${i + 1}: "From" cannot be less than the previous slab's "To".`;
            if (!this.slabRowValid(s)) return `Slab ${i + 1}: "To" must be greater than "From".`;
            if (s.multiplier === '' || isNaN(Number(s.multiplier)) || Number(s.multiplier) < 0) return `Slab ${i + 1}: enter a valid pay ratio.`;
          }
          return '';
        },
        // same walk as RosterOvertimeController::applySlabs
        slabExample() {
          const slabs = this.fdata.slabs;
          if (!slabs.length) return '';
          const last = slabs[slabs.length - 1];
          const hours = last.is_remaining ? Number(last.from_hr) + 2 : Number(last.to_hr);
          if (!(hours > 0)) return '';

          let parts = [], total = 0;
          for (const s of slabs) {
            const from = Number(s.from_hr);
            if (hours <= from) break;
            const end = s.is_remaining ? hours : Number(s.to_hr);
            const hrs = Math.min(hours, end) - from;
            if (hrs > 0) {
              parts.push(`(${+hrs.toFixed(2)} × ${Number(s.multiplier)})`);
              total += hrs * Number(s.multiplier);
            }
            if (s.is_remaining) break;
          }
          if (!parts.length) return '';

          let text = `Example: ${hours} extra hours = ${parts.join(' + ')} = ${+total.toFixed(2)} OT hour-equivalents.`;
          text += last.is_remaining
            ? ` The last slab covers all remaining hours after ${Number(last.from_hr)} hrs (still capped by Maximum Allowed OT).`
            : ` Hours beyond ${Number(last.to_hr)} are not paid; tick "Rem." on the last slab to cover them.`;
          return text;
        },
        paginatedLogs() {
          if (!Array.isArray(this.activityLogs)) return [];
          const start = (this.log_pagination.currentPage - 1) * this.log_temp_length;
          const end = start + this.log_temp_length;
          return this.activityLogs.slice(start, end);
        },

      }
}
</script>
